// @flow
import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { Link } from "react-router-dom";

export const Wrapper = styled.nav`
  display: flex;
  align-items: center;
  background-color: transparent;

  &:hover {
    cursor: pointer;
  }

  & > a {
    padding: 6px;
    border-radius: 4px;
    outline: none;
    align-items: center;
    display: flex;
    ${({ $isNear }) =>
      $isNear
        ? css`
            width: 34px;
            height: 44px;

            &:first-child {
              border-top-right-radius: 0;
              border-bottom-right-radius: 0;
            }

            &:last-child {
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
            }
          `
        : css`
            width: 32px;
            height: 32px;

            &:first-child {
              margin-right: 4px;
            }
          `}
  }
`;

const ArrowDisabledButton = ({ disabled, $isNightMode }) =>
  disabled &&
  !$isNightMode &&
  css`
    cursor: default;
    border-color: ${buildColor("grey", "D3")};
    opacity: 0.5;
  `;

const ArrowEnabledButton = ({ $isNightMode, $isNear }) =>
  !$isNightMode &&
  css`
    ${!$isNear && "opacity: 1;"}
    &:hover {
      background-color: ${buildColor("white", "default")};
    }

    &:active {
      background-color: ${buildColor("navy", $isNear ? "700" : "500")};
    }
  `;

export const ArrowButton = styled(Link)`
  border: 1px solid ${buildColor("blue")};
  margin: 0;
  ${({ $isNightMode }) =>
    !$isNightMode &&
    css`
      background-color: ${buildColor("white")};
    `};

  &:first-child {
    border-right: none;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: -1px;
      background: ${buildColor("blue")};
      width: 1px;
      height: 100%;
    }
  }

  ${({ disabled }) => (disabled ? ArrowDisabledButton : ArrowEnabledButton)}
`;
